import React, { createContext, useContext, useRef, useCallback, ReactNode } from "react";

type LoadingContextType = {
  registerStart: () => void;
  registerEnd: () => void;
  getCount:()=>number;
}

type LoadingProviderProps = {
  children: ReactNode;
};


const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

export function LoadingProvider({ children }:LoadingProviderProps) {
  const countRef = useRef(0);
  const [, setTick] = React.useState(0);

  const registerStart = useCallback(() => {
    countRef.current += 1;
    setTick(t => t + 1);
  }, []);

  const registerEnd = useCallback(() => {
    countRef.current = Math.max(0, countRef.current - 1);
    setTick(t => t + 1);
  }, []);

  return (
    <LoadingContext.Provider value={{ registerStart, registerEnd, getCount: () => countRef.current }}>
      {children}
    </LoadingContext.Provider>
  );
}

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (context === undefined) {
      throw new Error('useFTAImpactContext must be used within a FTAImpactProvider');
  }
  return context;
}